const wrapper = "_mww1jma4wr";
const closeButton = "_mwc10oqlaa";
const heading = "_mwh1j0sk9d";
const imageFigure = "_mwilt391i";
const image = "_mwi5bit6c";
const imageCaption = "_mwiiihdw7";
const body = "_mwb1fhoon3";
const linkButton = "_mwlcno4g";

export { body, closeButton, heading, image, imageCaption, imageFigure, linkButton, wrapper };
import "./molecule.hotspot-content.styles.linaria.module.css";
//# sourceMappingURL=molecule.hotspot-content.styles.js.map
